export default function About() {
  return (
    <main>
      <article>
        <section id="about" className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                  Your Trusted Partner in <strong>Waste Management</strong>
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-8">
                  At <strong>S2K Waste Services</strong>, we specialize in providing efficient <strong>skip hire solutions</strong> for homes, businesses, and construction sites in <strong>Kwa Zulu Natal</strong>. Our mission is simple: make <strong>waste disposal</strong> easy, eco-friendly, and cost-effective.
                </p>

                <div className="grid grid-cols-3 gap-8">
                  <div>
                    <div className="text-4xl font-bold text-orange-500 mb-2">15+</div>
                    <div className="text-sm text-gray-600">Years Experience</div>
                  </div>
                  <div>
                    <div className="text-4xl font-bold text-orange-500 mb-2">500+</div>
                    <div className="text-sm text-gray-600">Projects Completed</div>
                  </div>
                  <div>
                    <div className="text-4xl font-bold text-orange-500 mb-2">100%</div>
                    <div className="text-sm text-gray-600">Licensed & Insured</div>
                  </div>
                </div>
              </div>

              <div className="relative">
                <div className="rounded-3xl overflow-hidden shadow-2xl">
                  <img
                    src="https://public.readdy.ai/ai/img_res/7dcac6b0dd26dbc90ab7cf6dbcbb7e88.jpg"
                    alt="S2K Waste Services Team in Kwa Zulu Natal"
                    title="Professional Waste Management Team"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -top-6 -right-6 bg-white rounded-2xl shadow-lg px-6 py-4">
                  <div className="flex items-center space-x-3">
                    <i className="ri-leaf-fill text-green-500 text-3xl"></i>
                    <div>
                      <div className="text-sm font-bold text-gray-900">Eco-Certified</div>
                      <div className="text-xs text-gray-600">Green Disposal</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
    </main>
  );
}
